module.exports = __webpack_public_path__ + "img/rightBottom6.f20908c.svg";